import Context from './Context.js';

export default class Software extends Context {
  constructor(softwareVersion, templateId) {
    super();
    this.data = {
      software: softwareVersion,
      template: templateId ? templateId.toString() : 'no_template',
    };
  }

  static get key() {
    return 'software_event_context'
  }
}
